import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraBadge, SpecraButton } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
/**
 * A program document's processing outcome on the Docs page: "Processing"
 * while Specra reads it, "Failed" with its plain reason and Retry when the
 * read failed. A document that was only stored, or read cleanly, shows
 * nothing.
 */ export function DocumentProcessingStatus({ status, reason, onRetry }) {
    if (status === 'processing') {
        return /*#__PURE__*/ _jsx(SpecraBadge, {
            variant: "info",
            "data-testid": Testids.deliveryDocs.documentProcessingStatus,
            children: "Processing"
        });
    }
    if (status !== 'failed') return null;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col items-start gap-1",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center gap-2",
                children: [
                    /*#__PURE__*/ _jsx(SpecraBadge, {
                        variant: "danger",
                        "data-testid": Testids.deliveryDocs.documentProcessingStatus,
                        children: "Failed"
                    }),
                    onRetry && /*#__PURE__*/ _jsx(SpecraButton, {
                        size: "sm",
                        variant: "outline",
                        onClick: (e)=>{
                            e.stopPropagation();
                            onRetry();
                        },
                        "data-testid": Testids.deliveryDocs.documentRetry,
                        children: "Retry"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "text-xs text-muted-foreground",
                "data-testid": Testids.deliveryDocs.documentProcessingReason,
                children: reason || 'Specra could not read this document — try again'
            })
        ]
    });
}
